export default __webpack_public_path__ + "static/media/change_email.bdc2c65a.svg";